<template>
<div class="chapter">
<div class="inner_page">
<h1>Sommario</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titolo Pagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">Presa da Tre Guardie del Corpo (Ménage, #5)</a></p>
<p><a href="#/c004">Nota dell’Autrice</a></p>
<p><a href="#/c005">Capitolo I</a></p>
<p><span href="#/c006" title="Link target outside of Sample">Capitolo II</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Capitolo III</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Capitolo IV</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Capitolo V</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Capitolo VI</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Capitolo VII</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Capitolo VIII</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Altre storie di Jasmine Black in italiano:</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?26c16154